import React from "react";
import {
  generateCurvePath,
  generateSmartPath,
  generateRightAnglePath
} from "@mrblenny/react-flow-chart";
import { endP } from "../../../utils/editorUtils";
import { WorkflowCustomCallbacks } from "../workflow-custom-callbacks";

export function CustomLink({
  config,
  link,
  startPos,
  endPos,
  fromPort,
  toPort,
  onLinkMouseEnter,
  onLinkMouseLeave,
  onLinkClick,
  isHovered,
  isSelected,
  matrix
}) {
  const preEnd = endP(startPos, endPos, 0.99);
  const points = config.smartRouting
    ? !!toPort && !!matrix
      ? generateSmartPath(matrix, startPos, preEnd, fromPort, toPort)
      : generateRightAnglePath(startPos, preEnd)
    : generateCurvePath(startPos, preEnd);
  //calculates the direction in which the link moves to determine the orientation of the arrow head
  const width = Math.abs(startPos.x - endPos.x);
  const height = Math.abs(startPos.y - endPos.y);
  const leftToRight = startPos.x < endPos.x;
  const topToBottom = startPos.y < endPos.y;
  const isHorizontal = width > height;
  const StartArrow = isHorizontal ? leftToRight : topToBottom;
  const doubleDirection = link.properties
    ? link.properties.secondAssociation
    : null;
  return (
    <WorkflowCustomCallbacks.Consumer>
      {callbacks => (
        <svg
          style={{
            overflow: "visible",
            position: "absolute",
            cursor: "pointer",
            left: 0,
            right: 0
          }}
        >
          <circle r="5" cx={startPos.x} cy={startPos.y} fill="cornflowerblue" />
          {/* Main line */}
          <defs>
            <marker
              id="triangle"
              viewBox="0 0 10 10"
              refX="0"
              refY="5"
              markerUnits="strokeWidth"
              markerWidth="7"
              markerHeight="4"
              orient="auto"
            >
              <path d="M 0 0 L 10 5 L 0 10 z" stroke="grey" fill="grey" />
            </marker>
          </defs>
          <defs>
            <marker
              id="triangleStart"
              viewBox="0 0 10 10"
              refX="0"
              refY="5"
              markerUnits="strokeWidth"
              markerWidth="7"
              markerHeight="4"
              orient="auto"
            >
              <path d="M 0 5 l 10 -5 l 0 10 z" stroke="grey" fill="grey" />
            </marker>
          </defs>
          <path
            d={points}
            stroke="grey"
            strokeWidth="3"
            fill="none"
            markerStart={
              !StartArrow || doubleDirection ? "url(#triangleStart)" : ""
            }
            markerEnd={StartArrow || doubleDirection ? "url(#triangle)" : ""}
          />
          <path
            d={points}
            stroke="cornflowerblue"
            strokeWidth="20"
            fill="none"
            strokeLinecap="round"
            strokeOpacity={isHovered || isSelected ? 0.1 : 0}
            onMouseEnter={() => onLinkMouseEnter({ config, linkId: link.id })}
            onMouseLeave={() => onLinkMouseLeave({ config, linkId: link.id })}
            onDoubleClick={() => {
              callbacks.editPropertyLink(link);
            }}
            onClick={e => {
              onLinkClick({ config, linkId: link.id });
              e.stopPropagation();
            }}
          />
        </svg>
      )}
    </WorkflowCustomCallbacks.Consumer>
  );
}
